<script>
  import { config, results, searchCursor, searching } from '../store.js';
  import ResultItem from './result-item.svelte';
  import ResultMediaItem from './result-media-item.svelte';
</script>

<div
  class="dynamic-grid-layout results-list {$config.mosaicResults
    ? 'mosaic-results'
    : ''}"
  class:searching={$searching && $searchCursor.endCursor === 0}
>
  {#if $results.length > 0}
    {#each $results as result, index (result.id)}
      {#if $config.mediaGallery}
        <ResultMediaItem item={result} {index} />
      {:else}
        <ResultItem item={result} {index} />
      {/if}
    {/each}
  {:else}
    <span class="search-error"> No results. </span>
  {/if}
</div>
